import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Alice Bot - Ultimate WhatsApp Group Automation & Moderation",
  description = "Alice Bot - The ultimate WhatsApp group automation and moderation tool. Features auto-tagging, games, stickers, and 24/7 support.",
  image = "/icon.webp",
  url = "https://s00k-alice.vercel.app",
  type = "website",
  schema = null
}) => {
  const siteTitle = "Alice Bot";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      <link rel="canonical" href={url} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
